// extracted by mini-css-extract-plugin
export default {"LegendHeader":"G4NSQ","LegendItem":"zFvyF","Legend":"sQuRG","none":"Or6mk","vertical":"oMCKr","horizontal":"k8R4C"};